import { Box, makeStyles } from "@material-ui/core";
import React from "react";
import { FTLAvatar } from "../FTLAvatar";
import { FTLButton } from "../FTLButton";
import { CameraIcon, TrashIcon } from "../icons";
export const FTLPictureUpload = React.forwardRef(({ onDelete, onUpload, onFileSelect, onError, imageUrl, inputRef }, ref) => {
    const classes = useStyles();
    return (React.createElement("div", { ref: ref },
        React.createElement(FTLAvatar, { type: "avatar", size: "large", src: imageUrl, onError: onError }),
        React.createElement("input", { type: "file", style: { display: "none" }, name: "avatar", ref: inputRef, onChange: onFileSelect, accept: "image/*" }),
        React.createElement(Box, { display: "flex", width: "96px", justifyContent: "center", mt: 2 }, imageUrl ? (React.createElement(React.Fragment, null,
            React.createElement(FTLButton, { color: "secondary", onClick: onDelete, className: classes.button, style: { marginRight: 14 } },
                React.createElement(TrashIcon, { color: "secondary" })),
            React.createElement(FTLButton, { color: "secondary", onClick: onUpload, className: classes.button },
                React.createElement(CameraIcon, { color: "secondary" })))) : (React.createElement(FTLButton, { color: "secondary", onClick: onUpload }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C")))));
});
const useStyles = makeStyles((theme) => ({
    button: {
        width: 32,
        height: 32,
        "& span": {
            height: 24,
        },
    },
}));
//# sourceMappingURL=index.js.map